/**
 * Created by forbiz on 2021-12-08.
 */

const meals = () => {
	const $window = $(window);
	const $document = $(document);


	const meals_slider = () => {
		const $target = $('.meals__slider');
		const $length = $target.find('.slick-slide').length;
                
        if ( $length > 1 ) {
			hdFn.hdSlide( $target.find('.slick-slider'), {
	            arrows: true,
				autoplay: true,
				autoplaySpeed: 3000,
				cssEase: 'linear',
				dots: false,
				infinite: true,
				prevArrow: $('.meals__slider .btn__prev'),
				nextArrow: $('.meals__slider .btn__next'),
				speed: 300,
	        });
        } else{
        	$target.find(".btn__prev, .btn__next").hide();
			$target.find('.slick-slide').show();

        }
	};


	const mealsinit = () => {
	};
	
	mealsinit();

	window.meals_slider = meals_slider;

};

export default meals;
